import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) {}
  postLogin(formData: any): Observable<any> {
    // const data = JSON.stringify(formData.value);
    console.log("login data", formData);
    const data = {
      username: formData.login,
      password: formData.pass,
      type: formData.type ? formData.type : "RESTAURANT",
    };
    return this.http.post(environment.loginUrl + "login", data);
  }
}
